import { Component, OnInit, Input, TemplateRef, Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { UploadfileService } from '../../services/uploadfile.service';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { Router } from '@angular/router';
import { SWAlertService } from '../../services/swalert.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-uploadfile-box',
  templateUrl: './uploadfile-box.component.html',
  styleUrls: ['./uploadfile-box.component.css']
})
export class UploadfileBoxComponent implements OnInit {
  modalRef: BsModalRef;
  @Input() AttachedFile: any[];
  @Input() Multi: boolean;
  @Input() Size: number = 0;
  @Output() OnselectFile = new EventEmitter();
  Disinput: boolean = true;
  IsMulti: boolean = false;
  nSize: number;
  type: any[] = [];
  Txtfile = "Maximum size 5 MB / File, Allowed File Type: PDF, .pst, .msg, .doc, .docx, .xls, .xlsx, .xlsm, .ppt, .pptx, .jpg, .jpeg, .png, .gif";
  constructor(private http: HttpClient
    , private uploadService: UploadfileService
    , private System: TSFuntionService
    , private sanitized: DomSanitizer
    , private router: Router
    , private modalService: BsModalService
    , private SW: SWAlertService
    , private formBuilder: FormBuilder) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    if (this.AttachedFile.length != 0) {
      this.AttachedFile.forEach(f => {
        this.TAttachedFiles.push({
          FileName: f.FileName,
          IsNewFile: f.IsNewFile,
          SaveToFileName: f.SaveToFileName,
          SaveToPath: f.SaveToPath,
          nID: f.nID,
          sFileType: f.sFileType,
          IsDelete: f.IsDelete,

        })
        this.ID = f.nID;
      }
      )
    }
    this.IsMulti = this.Multi == true ? true : false;
    if (!this.IsMulti) {
      this.Disinput = this.TAttachedFiles.filter(f => f.IsDelete != true).length >= 1 ? true : false;
    }

  }

  Uploadfile(files: File[]) {
    if (this.CheckFilesize(files)) {
      if (files.length != 0) {
        this.uploadAttachedFile(files)
      }
    }
  }

  CheckFilesize(files: File[]) {
    let status = false;
    let max_size = this.Size * (1024 * 1024);
    let rr = files[0].size
    for (var i = 0; i < files.length; i++) {
      if (files[i].size <= max_size) {
        status = true;
      } else {
        status = false;
        this.SW.SwAlert.Error(this.SW.BoxMsg.Title_Error, files[i].name + " file exceeds limit", undefined)
        break;
      }
    }
    return status;
  }

  Delete(nID) {
    let _This = this;
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Delete, function () {
      _This.TAttachedFiles.forEach(f => {
        if (f.nID == nID) {
          f.IsDelete = true;
        }
        if (!_This.IsMulti) {
          _This.Disinput = _This.TAttachedFiles.filter(f => f.IsDelete != true).length >= 1 ? true : false;
        }
      })
      _This.OnselectFile.emit(_This.TAttachedFiles);
    }, undefined)

  }

  txtfile: string[] = [];
  TAttachedFiles: any[] = [];
  //LstAttachedFiles: TAttachedFiles[] = [];
  ID = 0;
  IsFileType: boolean = false;
  public uploadAttachedFile = (files: File[]) => {
    this.uploadService.uploadFile(files, "Temp")
      .subscribe(event => {

        if (event.type === HttpEventType.UploadProgress) {
          var progress = Math.round(100 * event.loaded / event.total);
          if (progress === 100) {
            this.System.BlockUI();
          }
        } else if (event.type === HttpEventType.Response) {
          this.System.UnBlockUI();
          event.body["lstData"].forEach(f => this.type.push(f.sFileType.split("/", 1)))
          event.body["lstData"].forEach(f => this.TAttachedFiles.push({
            FileName: f.fileName,
            IsNewFile: true,
            SaveToFileName: f.saveToFileName,
            SaveToPath: f.saveToPath,
            nID: ++this.ID,
            sFileType: f.sFileType,
            IsDelete: false,

          }))
          this.OnselectFile.emit(this.TAttachedFiles);
          if (!this.IsMulti) {
            this.Disinput = this.TAttachedFiles.filter(f => f.IsDelete != true).length >= 1 ? true : false;
          }
          //image
          //application
        }
      });
  }

  sURL: string = null;
  async View(template: TemplateRef<any>, nID: any) {
    let _data = this.TAttachedFiles.filter(f => f.nID == nID);
    this.sURL = _data[0].SaveToPath + "/" + _data[0].SaveToFileName;
    // window.open(this.sURL);
    const link = document.createElement('a');
    link.target = '_blank'
    link.href = this.System.SiteName + this.sURL;
    link.setAttribute('visibility', 'hidden');
    link.click();
  }


}
